import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { __i18n } from '@localisation';
import { NumberFormatService, TimeDateConverterService } from '@converter';

@Injectable()
@Pipe({
    name: 'formatM2MInformationItemValue',
    standalone: false
})
export class FormatM2MInformationItemValuePipe implements PipeTransform {
    constructor(
        private numberFormatter: NumberFormatService,
        private timeDateConverter: TimeDateConverterService
    ) {
        // nothing to do here.
    }

    public async transform(value: string, itemType: string, itemName: string, allowShortening: boolean = true): Promise<string> {
        if (value !== null && itemType !== null) {
            switch (itemType.toLowerCase()) {
                case 'datetime':
                    return this.timeDateConverter.convertFormat(value, 'datetimeseconds');

                case 'number':
                    return await this.numberFormatter.format(value, false, allowShortening);

                case 'string':
                    if (itemName) {
                        switch (itemName) {
                            case 'hasBeenActiveLive':
                            case 'sessionActive':
                                return value === 'Y'
                                    ? __i18n('Yes', 'm2m.informationitemvalue.yes')
                                    : value === 'N'
                                        ? __i18n('No', 'm2m.informationitemvalue.no')
                                        : value;

                            case 'sessionLastCellId':
                                if (value) {
                                    const match = /^(\d+)-(\d+)-(\d+)-(\d+)(?:-(\d+))?$/.exec(value);
                                    if (match) {
                                        return 'MMC=' + match[1]
                                            + ' MNC=' + match[2]
                                            + ' LAC=' + match[3]
                                            + ' CID=' + match[4];
                                    }
                                }
                        }
                    }
            }
        }
        return value;
    }
}
